var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgArrowBottom(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.173 7.183L5.822 12l5.65-4.817a.53.53 0 00.16-.162.438.438 0 00.031-.415.502.502 0 00-.136-.179.604.604 0 00-.21-.114.675.675 0 00-.484.033.567.567 0 00-.186.14l-4.24 3.604V.501a.468.468 0 00-.171-.354A.638.638 0 005.822 0a.638.638 0 00-.413.147.468.468 0 00-.172.354v9.59L.997 6.485a.639.639 0 00-.414-.145.637.637 0 00-.413.148.468.468 0 00-.17.355c0 .133.063.26.173.354v-.015z",
    fill: "#535353"
  })));
}

export default SvgArrowBottom;